import React, { Fragment } from "react";
import DocumentTitle from "react-document-title";
import { ModalContainer } from "react-router-modal";

import Notifications from "./base/containers/Notifications";
import Header from "./nav/containers/Header";
import Routes from "./routes";
import ModalRoot from "./shared/containers/ModalRoot";

const App = () => (
  <Fragment>
    <DocumentTitle title="RBAC" />
    <Header />
    <Routes />
    <ModalContainer
      containerClassName="p-modal"
      modalClassName="p-modal__dialog"
      wrapperClassName="p-modal__wrapper"
    />
    <Notifications />
    <ModalRoot />
  </Fragment>
);

export default App;
